import React from 'react';
import { faCircleCheck } from '@fortawesome/free-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import blackGif from '../../../images/gif/black.gif';

const OfferTicket = () => {
    return (
        <div style={{ backgroundImage: `url(${blackGif})`, backgroundSize: 'cover', backgroundPosition: 'center', borderRadius: 20, padding: 15, color: 'gold' }}>
            <div className="text-center">
                <h1 data-aos="fade-up" data-aos-duration="1000" className="fw-bolder">Choose <span style={{ color: '#ff3465' }}>the best package</span> for you</h1>
                <p data-aos="fade-up" data-aos-duration="2000">Nostra venenatis blandit venenatis tortor consequat phasellus convallis quam augue nulla sit habitant fames taciti fermentum. Dolor tempor primis tortor massa.</p>
            </div>
            <div className="row">
                <div className="col-lg-4">
                    <div style={{ margin: 5, border: '8px solid #8ef9f4a3', padding: '25px 15px', borderRadius: 15 }}>
                        <div className="text-center">
                            <span data-aos="fade-up" style={{ background: '#8EF9F3', color: 'black', padding: '2px 15px', borderRadius: 10, fontWeight: 800 }}>Basic</span>
                            <h1 data-aos="fade-up" data-aos-duration="1000" className="fw-bolder mt-3">$250</h1>
                            <p data-aos="fade-up" data-aos-duration="2000">netto</p>
                        </div>
                        <div data-aos="fade-up" data-aos-duration="500" className="d-flex">
                            <p><FontAwesomeIcon icon={faCircleCheck} /></p>
                            <p className="ps-2">Nunc justo non leo non dui dui</p>
                        </div>
                        <div data-aos="fade-up" data-aos-duration="1000" className="d-flex">
                            <p><FontAwesomeIcon icon={faCircleCheck} /></p>
                            <p className="ps-2">Fusce tempor elit purus</p>
                        </div>
                        <div data-aos="fade-up" data-aos-duration="1500" className="d-flex">
                            <p><FontAwesomeIcon icon={faCircleCheck} /></p>
                            <p className="ps-2">Nec scelerisque urna sit</p>
                        </div>
                        <div data-aos="fade-up" data-aos-duration="2000" className="d-flex">
                            <p><FontAwesomeIcon icon={faCircleCheck} /></p>
                            <p className="ps-2">Quisque sed libero laoreet</p>
                        </div>
                        <div data-aos="fade-up" data-aos-duration="2500" className="d-flex">
                            <p><FontAwesomeIcon icon={faCircleCheck} /></p>
                            <p className="ps-2">Ligula dui, non eros bibendum</p>
                        </div>
                        <div data-aos="fade-up" data-aos-duration="3000" className="d-flex">
                            <p><FontAwesomeIcon icon={faCircleCheck} /></p>
                            <p className="ps-2">Accumsan sit amet turpis</p>
                        </div>
                        <div data-aos="fade-up" data-aos-duration="3000" className="d-flex">
                            <p><FontAwesomeIcon icon={faCircleCheck} /></p>
                            <p className="ps-2">Sed malesuada fames</p>
                        </div>
                    </div>
                </div>
                <div className="col-lg-4">
                    <div style={{ margin: 5, border: '8px solid #ff346382', padding: '25px 15px', borderRadius: 15 }}>
                        <div className="text-center">
                            <span style={{ background: '#FF3465', color: 'white', padding: '2px 15px', borderRadius: 10, fontWeight: 800 }}>Compact</span>
                            <h1 data-aos="fade-up" data-aos-duration="1000" className="fw-bolder mt-3">$500</h1>
                            <p data-aos="fade-up" data-aos-duration="2000">netto</p>
                        </div>
                        <div data-aos="fade-up" data-aos-duration="500" className="d-flex">
                            <p><FontAwesomeIcon icon={faCircleCheck} /></p>
                            <p className="ps-2">Nunc justo non leo non dui dui</p>
                        </div>
                        <div data-aos="fade-up" data-aos-duration="1000" className="d-flex">
                            <p><FontAwesomeIcon icon={faCircleCheck} /></p>
                            <p className="ps-2">Fusce tempor elit purus</p>
                        </div>
                        <div data-aos="fade-up" data-aos-duration="1500" className="d-flex">
                            <p><FontAwesomeIcon icon={faCircleCheck} /></p>
                            <p className="ps-2">Nec scelerisque urna sit</p>
                        </div>
                        <div data-aos="fade-up" data-aos-duration="2000" className="d-flex">
                            <p><FontAwesomeIcon icon={faCircleCheck} /></p>
                            <p className="ps-2">Quisque sed libero laoreet</p>
                        </div>
                        <div data-aos="fade-up" data-aos-duration="2500" className="d-flex">
                            <p><FontAwesomeIcon icon={faCircleCheck} /></p>
                            <p className="ps-2">Ligula dui, non eros bibendum</p>
                        </div>
                        <div data-aos="fade-up" data-aos-duration="3000" className="d-flex">
                            <p><FontAwesomeIcon icon={faCircleCheck} /></p>
                            <p className="ps-2">Accumsan sit amet turpis</p>
                        </div>
                        <div data-aos="fade-up" data-aos-duration="3000" className="d-flex">
                            <p><FontAwesomeIcon icon={faCircleCheck} /></p>
                            <p className="ps-2">Sed malesuada fames</p>
                        </div>
                    </div>
                </div>
                <div className="col-lg-4">
                    <div style={{ margin: 5, border: '8px solid #ffc2508c', padding: '25px 15px', borderRadius: 15 }}>
                        <div className="text-center">
                            <span style={{ background: '#FFC250', color: 'black', padding: '2px 15px', borderRadius: 10, fontWeight: 800 }}>Basic</span>
                            <h1 data-aos="fade-up" data-aos-duration="1000" className="fw-bolder mt-3">$1000</h1>
                            <p data-aos="fade-up" data-aos-duration="2000">netto</p>
                        </div>
                        <div data-aos="fade-up" data-aos-duration="500" className="d-flex">
                            <p><FontAwesomeIcon icon={faCircleCheck} /></p>
                            <p className="ps-2">Nunc justo non leo non dui dui</p>
                        </div>
                        <div data-aos="fade-up" data-aos-duration="1000" className="d-flex">
                            <p><FontAwesomeIcon icon={faCircleCheck} /></p>
                            <p className="ps-2">Fusce tempor elit purus</p>
                        </div>
                        <div data-aos="fade-up" data-aos-duration="1500" className="d-flex">
                            <p><FontAwesomeIcon icon={faCircleCheck} /></p>
                            <p className="ps-2">Nec scelerisque urna sit</p>
                        </div>
                        <div data-aos="fade-up" data-aos-duration="2000" className="d-flex">
                            <p><FontAwesomeIcon icon={faCircleCheck} /></p>
                            <p className="ps-2">Quisque sed libero laoreet</p>
                        </div>
                        <div data-aos="fade-up" data-aos-duration="2500" className="d-flex">
                            <p><FontAwesomeIcon icon={faCircleCheck} /></p>
                            <p className="ps-2">Ligula dui, non eros bibendum</p>
                        </div>
                        <div data-aos="fade-up" data-aos-duration="3000" className="d-flex">
                            <p><FontAwesomeIcon icon={faCircleCheck} /></p>
                            <p className="ps-2">Accumsan sit amet turpis</p>
                        </div>
                        <div data-aos="fade-up" data-aos-duration="3000" className="d-flex">
                            <p><FontAwesomeIcon icon={faCircleCheck} /></p>
                            <p className="ps-2">Sed malesuada fames</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default OfferTicket;